module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tt-faa91be4a726ae707d5d6d540c79e81b.svg";